import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Leaf, MailCheck } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PasswordInput } from "../components/PasswordInput";

export default function InvitePage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [invite, setInvite] = useState(null);
  const [invalid, setInvalid] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setInvalid("Geçersiz bağlantı. Lütfen e-postanızdaki davet bağlantısını kullanın.");
      return;
    }
    api.get("/invites/validate", { params: { token } })
      .then((r) => setInvite(r.data))
      .catch((e) => setInvalid(formatApiError(e.response?.data?.detail)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== password2) {
      setError("Şifreler eşleşmiyor");
      return;
    }
    setLoading(true);
    try {
      await api.post("/invites/accept", { token, name, password });
      window.location.href = "/";
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F7F7F6] px-6">
      <div className="fade-up w-full max-w-sm">
        <div className="mb-8 flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center bg-[#1C4E35]">
            <Leaf size={18} className="text-[#8FD4AC]" />
          </div>
          <span className="font-heading text-base font-black tracking-tight">COP31 PORTAL</span>
        </div>
        {invalid ? (
          <div className="border border-red-300 bg-red-50 p-6 text-sm text-red-700" data-testid="invite-invalid">
            {invalid}
            <Link to="/login" className="mt-3 block font-medium text-[#1C4E35] hover:underline">Giriş sayfasına dön</Link>
          </div>
        ) : !invite ? (
          <div className="flex h-32 items-center justify-center" data-testid="invite-loading">
            <div className="h-5 w-5 animate-spin rounded-full border-2 border-[#1C4E35] border-t-transparent" />
          </div>
        ) : (
          <form onSubmit={submit} className="border border-stone-200 bg-white p-6" data-testid="invite-form">
            <MailCheck size={30} className="text-[#1C4E35]" />
            <h1 className="font-heading mt-3 text-xl font-black tracking-tight">Davetlisiniz</h1>
            <p className="mt-1 text-sm text-stone-600" data-testid="invite-info">
              <strong>{invite.email}</strong> adresi için {invite.role === "admin" ? "Yönetici" : "Firma Kullanıcısı"} hesabı
              {invite.organisation ? <> (<strong>{invite.organisation}</strong>)</> : null} oluşturulacak.
            </p>
            <div className="mt-5 space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Ad Soyad</Label>
                <Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="invite-name-input" className="rounded-sm border-stone-300" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Şifre</Label>
                <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} required testId="invite-password-input" />
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wider text-stone-600">Şifre (Tekrar)</Label>
                <PasswordInput value={password2} onChange={(e) => setPassword2(e.target.value)} required testId="invite-password2-input" />
              </div>
              {error && <p className="text-sm text-red-600" data-testid="invite-error">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="invite-submit" className="w-full rounded-sm bg-[#1C4E35] text-white hover:bg-[#143A26] active:scale-95">
                {loading ? "Oluşturuluyor..." : "Hesabı Oluştur ve Giriş Yap"}
              </Button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
